module.exports = __webpack_public_path__ + "static/media/pencil.182e6a86.svg";